<template>
	<div class="baoyang-payload">

		<div class="psearch">
			<van-sticky>
				<van-search 
					v-model="search.kws" 
					placeholder="请输入搜索关键词" 
					@search="onSearch"
				/>
			</van-sticky>
		</div>

		<div v-if="pageItem.length > 0" class="pitem">
			<van-list
				v-model="querys.loading"
				:finished="querys.finished"
				finished-text="没有更多了"
				@load="onNextPage"
			>
				<template v-for="(item,idx) in pageItem" >
					<van-cell>
						<template slot="icon">
							<van-image
								class="pimage"
								width="60"
								height="60"
								:src="item.poster"
							/>
						</template>
						<template slot="title">
							{{item.slogan}}
						</template>
						<template slot="label">
							<div class="prow" v-if="item.carCode != ''">车辆型号：{{item.carCode}}</div>
							<div class="prow" v-if="item.engine !=''">发动机型号：{{item.engine}}</div>
							<div class="prow" v-if="item.oserverName != ''">服务项目：{{item.oserverName}}</div>
							<div class="prow" v-if="item.volume != ''">机油用量：{{item.volume}}L</div>

							<div class="prow money">活 动 价：<span class="num">{{formatMoney(item.money)}}元</span></div>
						</template>
						<template slot="right-icon">
							<div class="pright">
								<div>
									<!-- <van-icon 
										v-if="idx == 0"
										class="selected" 
										name="circle" 
										size="20px"
										color="#909399"
									/>
										<van-icon 
										v-if="idx == 1"
										class="selected" 
										name="passed" 
										size="20px" 
										color="#67C23A"
									/> -->
								</div>

								<van-tag 
									class="send"
									type="primary"
									size="medium"
									@click="handleSend(idx)"
								> 发送 </van-tag>

							</div>
						</template>
					</van-cell>
				</template>
			</van-list>
		</div>

		<div v-else class="pitem">
			<div v-if="querys.loading" class="load">
				<van-loading 
					size="36px"
					type="spinner"
				/>
			</div>
			<van-empty v-else description="暂未设置特惠车型!" />
		</div>

		<!--分享弹框-->
		<van-popup 
			v-model="send.show" 
			position="bottom" 
			:style="{ height: '60vh' }" 

		>
			<div class="send-payload">
				<div class="title">请选择发送方式</div>
				<div class="content">
					<!-- <van-row>
						<van-col :span="12">
							<div class="thalf">
								<div class="stext">
									<div class="stitle">{{send.text.title}}</div>
									<div class="slink">{{send.text.url}}</div>
								</div>
							</div>
						</van-col>
						<van-col :span="12"> -->
							<div class="thalf onehalf">
								<div class="tmini">
									<div class="ttitle">{{send.mini.title}}</div>
									
									<van-image
										class="timage"
										width="150"
										height="150"
										:src="send.mini.image"
									/>
								</div>
							</div>
						<!-- </van-col>
					</van-row> -->
				</div>
				<van-tabbar v-model="send.type">
					<!-- <van-tabbar-item icon="link-o" @click="handlClickShare('text')">发送文字链接</van-tabbar-item> -->
					<van-tabbar-item icon="miniprogram-o" @click="handlClickShare('mini')">发送小程序</van-tabbar-item>
				</van-tabbar>
			</div>
		</van-popup>
	</div>
</template>

<script type="text/javascript">
import {wxminiCfg} from '@/config/wxmini';
import {getQwSignature} from '@/interface/qywx/qwglobal';

import {getSpecial} from '@/interface/oms/operate/server';

export default {
	data(){
		return {
			//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qywx',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
			querys:{
				loading: false,
				finished: true
			},
			send:{
				type: '',
				show: false,
				currentIdx: '',
				text:{
					title: '',
					url: ''
				},
				mini:{
					title: '',
					image: ''
				}	
			},
			search:{
				kws: '',
				page: 1,
				psize: 10,
				orby: '',
				sort: '',
			},
			pageItem:[]
		}
	},
	created: function() {
		this.getQywxCfg();
		this.onSearch();
	},
	methods:{
		handleSend: function(idx){
			let current = this.pageItem[idx];

			let title = current.slogan+' '+current.oserverName+' ('+current.money+'元)';

			this.send.text = {
				title: title,
				url: '分享短连接',
			}
			this.send.mini = {
				title: title,
				image: current.poster,
				url: 'pweibao/baoyang/specialInfo/specialInfo.html?planId='+current.planId+''
			}

			this.send.currentIdx = idx;
			this.send.show = true;
		},
		handlClickShare: function(type){
			if( type == 'mini' ){
				let miniData = {
					title: this.send.mini.title,
					imgUrl: this.send.mini.image,
					page: this.send.mini.url
				}

				this.sendMiniProgram( miniData );
				this.send.show = false;
			}
		},
		onSearch: function(){
			this.search.page = 1;
			this.pageItem = [];

			this.getPageData(this.search);
		},
		onNextPage: function(){
			this.search.page = this.search.page + 1;

			this.getPageData(this.search);
		},
		getPageData: function(search){
			this.querys.loading = true;
			getSpecial(search)
				.then(res=>{
					if( res.status && ('items' in res.response) ){

						if( res.response.items.length > 0 ){
							let _this = this;
							res.response.items.forEach( function(item){
								let row = {
									planId: item.planId,
									carCodeId:item.carCodeId,
									carCode: item.carCode,
									engine: item.engine,
									money: item.money,
									oserverId: item.oserverId,
									oserverName: item.oserverName,
									volume: item.volume,
									poster: item.poster,
									slogan: item.slogan,
								}

								_this.pageItem.push(row);
							})
						}

						this.querys.finished = this.pageItem.length >= res.response.total;
					}

					this.querys.loading = false;
				})
				.catch(err=>{})
		},
		formatMoney: function(money){
			return parseFloat(money).toFixed(2);
		},
		//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享小程序
		 *@param map miniData 小程序参数
		 *			title: 	标题
		 *			imageUrl 图片路径，以.html结尾
		 *			page:   跳转路径
		 */
		sendMiniProgram: function(miniData){
			let pageUrl = miniData.page;
				pageUrl+= '&thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;

			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: wxminiCfg.newClient.appId,
					title: miniData.title,
					imgUrl: miniData.imgUrl,
					page: pageUrl,
				},
				success(res){
					// alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					// alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		},
	}
}
</script>